import { render, staticRenderFns } from "./Postales.vue?vue&type=template&id=545ad17a"
import script from "./Postales.vue?vue&type=script&lang=js"
export * from "./Postales.vue?vue&type=script&lang=js"
import style0 from "./Postales.vue?vue&type=style&index=0&id=545ad17a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports